var exports = {
  "w": "xcc377c0b--b8140a--logo",
  "n": "xcc377c0b--b8140a--link",
};

module.exports = exports;
